import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const radioWrapper = css`
  display: flex;
`;

export const secondaryLabel = css`
  flex-grow: 1;
  align-self: center;
  text-align: right;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-40);
  font-weight: 400;
  margin-bottom: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-bottom: ${spacing.sm}px;
    `,
  )};
`;

export const radioButtonWrapperContainer = css`
  display: flex;
  position: relative;
`;

export const radioButtonRow = css`
  position: relative;
  flex: 1;
`;

export const radioButtonForeground = css`
  position: relative;
  z-index: 1;
`;

export const linkUnderlay = css`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: auto;
`;
